export function get() {
    const color = localStorage.getItem('color');

    return color !== null ? color : 'blue';
}

export function set(value) {
    localStorage.setItem('color', value);
}